<template>
  <v-select
    class="mr-4"
    v-model="selectedEtablissement"
    return-object
    :items="etablissements"
    item-text="raisonSociale"
    :label="label"
    :style="{ maxWidth: '260px' }"
    dense
    outlined
    :append-icon="selectedEtablissement && etablissements.length <= 1 ? '' : '$dropdown'"
    :disabled="selectedEtablissement && etablissements.length <= 1"
    hide-details
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'etablissement-picker',
  computed: {
    ...mapGetters({
      getSelectableEtablissements: 'etablissement/getSelectableEtablissements',
      getSelectedEtablissement: 'application/getSelectedEtablissement',
    }),
    etablissements() {
      return this.getSelectableEtablissements
    },
    nbEtablissementsSelectionnables() {
      return this.getSelectableEtablissements.length
    },
    selectedEtablissement: {
      get() {
        return this.getSelectedEtablissement
      },
      set(_etablissement) {
        this.selectEtablissement(_etablissement)
      },
    },
    label() {
      if (!this.selectedEtablissement) {
        return 'Etablissement'
      } else {
        return undefined
      }
    },
  },
  watch: {
    nbEtablissementsSelectionnables() {
      if (this.nbEtablissementsSelectionnables === 1) {
        this.selectEtablissement(this.getSelectableEtablissements[0])
      }
    },
  },
  methods: {
    ...mapActions({
      selectEtablissement: 'application/selectEtablissement',
    }),
  },
}
</script>

<style scoped></style>
